import ThosCartStateReducer from "@thos/Store/Data/Checkout/ThosCartStateReducer";
import ThosSubmitForApprovalReducer from "@thos/Store/Data/Checkout/ThosSubmitForApprovalReducer";
import CustomerPartNumbersReducer from "@thos/Store/Data/CustomerPartNumbers/CustomerPartNumbersReducer";
import OrderHistoryReducer from "@thos/Store/Data/OrderHistory/OrderHistoryReducer";
import ProductsByCustomerVariantReducer from "@thos/Store/Data/ProductDetails/ProductsByCustomerVariantReducer";
import ShipFromWarehouseReducer from "@thos/Store/Data/ShipFromWarehouse/ShipFromWarehouseReducer";
import MyPartNumbersReducer from "@thos/Store/Pages/MyPartNumbers/MyPartNumbersReducer";
import { combineReducers } from "redux";

const customReducers = {
    OrderHistory: OrderHistoryReducer,
    customerPartNumbers: CustomerPartNumbersReducer,
    myPartNumbers: MyPartNumbersReducer,
    cartState: ThosCartStateReducer,
    shipFromWarehouseState: ShipFromWarehouseReducer,
    productsByVariantState: ProductsByCustomerVariantReducer,
    thosSubmitForApprovalState : ThosSubmitForApprovalReducer
};

export type CustomDataReducers = typeof customReducers;

const customDataReducer = combineReducers(customReducers as any);

export default customDataReducer;
